// extracted by mini-css-extract-plugin
export default {"post-ans-container":"postAnswer_post-ans-container__DF5nq","postAnsBtn":"postAnswer_postAnsBtn__QBVzO","ansTags":"postAnswer_ansTags__4QkmQ","link":"postAnswer_link__kkA2I"};